import Store from "../store/index";
import { routes } from "./routes";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

router.beforeEach((to, from, next) => {
	const roles = Store.getters["auth/roles"];
	const isAuthenticated = Store.getters["auth/authenticated"];
	const isLogin = to.name;
	const isGuest = to.meta.guest;

	if (to.meta.title) {
		document.title = to.meta.title;
	}

	if (isLogin == "Login" && isAuthenticated) next({ name: "Dashboard" });

	if (!isGuest && isLogin !== "Login" && !isAuthenticated)
		next({ name: "Login" });
	else {
		if (roles[to.meta.gate] === null || roles[to.meta.gate] === 0) {
			Store.dispatch(
				"snackbar/show",
				"403 : You do not have permission to access !"
			);
			next(from);
		} else next();
	}
});

export default router;
